module.exports = __webpack_public_path__ + "img/emiarch-2-sel.83c0da33.svg";